import NBType, { InferType } from '@netbase/nb-type'
import LogInfoSchema from './LogInfoSchema'
import ParamSchema from './ParamSchema'
import ServicePropertySchema from './ServicePropertySchema'
import ServiceType from '../enums/ServiceType'
import TopicSchema from './TopicSchema'

const ServiceSchema = NBType.object().shape('ServiceSchema', {
  /* @prop */
  comparedTopicDTOs: NBType.array().of(TopicSchema),
  /* @prop */
  id: NBType.number(),
  /* @prop */
  logInfoDto: LogInfoSchema,
  /* @prop */
  parameters: ParamSchema,
  /* @prop */
  properties: ServicePropertySchema,
  /* @prop */
  type: NBType.enum(ServiceType)
  /* END */
})
export default ServiceSchema
export type Service = InferType<typeof ServiceSchema>
// RESERVE BELOW
